import { escapeCsvField } from './csvExport';
import { taxYearUtc } from './fiTaxYear';
import * as taxPipelineConfig from './taxPipelineConfig';
import type { LedgerEvent } from './types';

/** Taxable income rows: `kind: income` with explicit Finnish income tagging (Phase 2). */
export function isTaxableIncomeLedgerEvent(e: LedgerEvent): boolean {
  return e.kind === 'income' && e.fiTaxCategory === 'TAXABLE_INCOME';
}

/**
 * All-time taxable income (Finnish disclosure): FMV at receipt = FIFO acquisition basis.
 */
export function buildFiIncomeAllTimeCsv(events: LedgerEvent[]): string {
  const meta = taxPipelineConfig.TAX_PIPELINE.fi;
  const headers = [
    'policy_mode',
    'basis_method',
    'timezone',
    'timestamp_utc',
    'tax_year',
    'source',
    'asset',
    'quantity',
    'EUR_FMV_at_receipt',
    'EUR_FMV_at_receipt_full_eur',
    'original_transaction_type',
    'reference_tx_or_id',
    'fi_tax_category',
    'fi_subreason',
    'review_flags',
    'rationale',
  ];
  const rows = events.filter(isTaxableIncomeLedgerEvent);
  rows.sort((a, b) => a.ts - b.ts);
  const lines = [headers.map(escapeCsvField).join(',')];
  for (const e of rows) {
    const iso = new Date(e.ts).toISOString();
    const amt = e.amount?.toFixed != null ? e.amount.toFixed(8) : String(e.amount);
    const eurFull =
      e.eurValue != null && e.eurValue.toFixed != null ? e.eurValue.toFixed(8) : '';
    const eur =
      e.eurValue != null && e.eurValue.toFixed != null ? e.eurValue.toFixed(2) : '';
    const flags = Array.isArray(e.reviewFlags) ? e.reviewFlags.join(';') : '';
    const origType =
      e.csvMeta?.transactionKind?.trim() ||
      e.csvMeta?.transactionDescription?.trim() ||
      e.classification ||
      '';
    lines.push(
      [
        meta.policyMode,
        meta.basisMethod,
        meta.timezone,
        iso,
        String(taxYearUtc(e.ts)),
        e.source,
        e.asset,
        amt,
        eur,
        eurFull,
        origType,
        e.ref ?? '',
        e.fiTaxCategory ?? '',
        e.fiSubreason ?? '',
        flags,
        e.explanation ?? '',
      ]
        .map(escapeCsvField)
        .join(',')
    );
  }
  return lines.join('\r\n');
}
